import { animate, style, transition, trigger } from '@angular/animations';

export const SMOOTH_ENTER_LEAVE = trigger('smoothing', [
  transition(':enter', [
    style({ opacity: 0, height: '90%' }),
    animate('200ms ease-in-out', style({ opacity: 1, height: '*' }))
  ]),
  transition(':leave', [
    style({ opacity: 1, height: '*' }),
    animate('100ms ease-in-out', style({ opacity: 0, height: '90%' }))
  ])
]);
